export enum DrawerDirection {
  FROM_RIGHT = 'right',
  FROM_LEFT = 'left',
  FROM_BOTTOM = 'bottom',
}
